// redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slice/authSlice";    // use consistent naming
import tutorExamReducer from "./slice/tutorExamSlice";
import registerReducer from "./slice/registerSlice"; // use consistent naming

export const store = configureStore({
  reducer: {
    auth: authReducer,
    exam: tutorExamReducer,
    register: registerReducer, // use consistent naming
  },
});
